import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { navLinks, linkHubDropdown } from '../data/dummyData';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const isMobile = window.innerWidth <= 768;

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLinkHubClick = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  // Reset dropdown when menu closes
  useEffect(() => {
    if (!isOpen) {
      setDropdownOpen(false);
    }
  }, [isOpen]);

  const handleDropdownLinkClick = () => {
    setDropdownOpen(false);
    if (isMobile) {
      setIsOpen(false); // Close mobile menu if open
    }
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo */}
        <div className="navbar-logo">
          <Link to="/" className="logo-link">
            <span className="logo-text">CBC Center</span>
            <span className="logo-subtitle">Education Resources</span>
          </Link>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="mobile-menu-btn" 
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span className={`hamburger ${isOpen ? 'open' : ''}`}></span>
        </button>

        {/* Navigation Links */}
        <ul className={`nav-links ${isOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.id} className={link.dropdown ? 'dropdown-item' : ''}>
              {link.dropdown ? (
                <div ref={dropdownRef}>
                  <button
                    className="nav-link dropdown-toggle"
                    onClick={handleLinkHubClick}
                    aria-expanded={dropdownOpen}
                    aria-haspopup="true"
                  >
                    {link.title}
                  </button>
                  <ul className={`dropdown-menu ${dropdownOpen ? 'active' : ''}`}>
                    {linkHubDropdown.map((dropdownLink) => (
                      <li key={dropdownLink.id}>
                        <Link 
                          to={dropdownLink.path} 
                          className="dropdown-link"
                          onClick={handleDropdownLinkClick}
                        >
                          {dropdownLink.title}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <Link 
                  to={link.path} 
                  className="nav-link"
                  onClick={() => {
                    setIsOpen(false);
                    setDropdownOpen(false);
                  }}
                >
                  {link.title}
                </Link>
              )}
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;